// extracted by mini-css-extract-plugin
export default {"SideNav":"SideNav_SideNav__8LyN+","LinkContainer":"SideNav_LinkContainer__rEokD","Link":"SideNav_Link__vBzvj","login-with-google-btn":"SideNav_login-with-google-btn__cQI1C"};